module.exports = "### 客户简介\r\n“咪咕学堂”是由咪咕数字传媒有限公司面向中小学、职业、出国留学和幼儿教育类学习群体，打造的一站式贴心学习服务平台。提供海量优质学习资源，包括直播课程、视频课程；整合学习兴趣圈等互动能力，创新“练学测疑”闭环型微学习模式。"